export enum AttachmentCategoryType {
    DelegationLetter = '51643945-0f7c-4ab0-a257-00e3e45513d9',
    CommercialRegistrationDocument = '6ce6a706-ff0b-41ce-af83-012b58868657',
    Other = '12e505a6-2103-4537-a913-0cab06052488',
    HRSDLicense = 'e4c1b839-cd40-4f0e-b1d8-0d42f7c30a95',
    InternationalCommercialRegistrationNumber = 'c7da0e90-0016-49c0-a045-14dd67d1a350',
    BudgetNumber = 'f188ad41-9795-4d6d-b1df-19d433c4b72d',
}